'use client';

import { type ReactNode } from 'react';
import { useIsClient } from 'usehooks-ts';

export const ClientOnly = ({
  children,
  fallback,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) => {
  const isClient = useIsClient();

  if (!isClient) {
    return fallback || null;
  }

  return children;
};
